import { render } from "./CustomJsonComponent.vue?vue&type=template&id=1c8a6fd5&ts=true"
import script from "./CustomJsonComponent.vue?vue&type=script&lang=ts"
export * from "./CustomJsonComponent.vue?vue&type=script&lang=ts"

import "./CustomJsonComponent.vue?vue&type=style&index=0&id=1c8a6fd5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__